export default __webpack_public_path__ + "static/media/support-notes-main-en-concreto.08fef5b9.png";